<template v-if="list.length" lang="html">
  <div>
    <table class="vcv-table">
      <thead>
        <row-header />
      </thead>
      <tbody>
        <row-editable
          v-for="(item, index) in sortedList"
          :key="item.localId"
          :model="item"
          :last-row="index === sortedList.length - 1"
          :recruiter-country="recruiterCountry"
          :edited="check(item)"
          :company="company"
          :is_japan_locale="is_japan_locale"
          :query-vacancy="!index ? queryVacancy : null"
          @delete-row="deleteRow(item.localId)"
        />
      </tbody>
    </table>

    <vpagination
      v-if="totalPages && totalPages > 1"
      :params="{
        pageNumber: page,
        totalPages: totalPages,
        count: pageSize
      }"
      :on-page-change="onPageChange"
      :has_load_more="false"
      :show-loadmore-button="false"
      :loading="paginationLoading"
      class="bottom"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { getCountryCallingCode } from 'libphonenumber-js';
import RowEditable from './row-editable/index';
import RowHeader from './row-header/index';

export default {
  name: 'InvitesList',
  components: {
    RowEditable,
    RowHeader
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },

    recruiterCountry: {
      type: String,
      default: ''
    },

    queryVacancy: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      page: 1,
      pageSize: 20,
      paginationLoading: false,
      getCountryCallingCode: getCountryCallingCode
    };
  },

  computed: {
    ...mapState({ vacancies: 'vacancies/list_dropdown' }),
    ...mapGetters({
      company: 'company/one',
      is_japan_locale: 'locale/is_japan_locale'
    }),

    sortedList() {
      if (!this.list || !this.list.length) {
        return [];
      }

      return this.paginate(this.list, this.pageSize, this.page);
    },

    totalItems() {
      if (!this.list || !this.list.length) {
        return 1;
      }
      return this.list.length;
    },

    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },

    lastRowNotEmpty() {
      const lastRow = [...this.list].pop();
      if (lastRow) {
        return !!(
          lastRow.vacancy.id ||
          lastRow.candidate.name ||
          lastRow.candidate.surname ||
          lastRow.candidate.email ||
          lastRow.candidate.phone
        );
      }

      return false;
    }
  },

  watch: {
    lastRowNotEmpty(val) {
      if (val) {
        this.$store.commit('invites/creation/createNewEmptyRow');
      }
    }
  },

  beforeMount() {
    this.CHANGE_PAGINATION_COUNT(20);
  },

  beforeDestroy() {
    this.CHANGE_PAGINATION_COUNT(20);
  },

  methods: {
    ...mapMutations('vacancies', ['CHANGE_PAGINATION_COUNT']),

    check(item) {
      if (item.edited) {
        return true;
      }
      if (item.errors) {
        return true;
      }
      return false;
    },

    deleteRow(localId) {
      if (this.list.length === 1) {
        this.$store.dispatch('invites/creation/clearRow', localId);
      } else {
        this.$store.dispatch('invites/creation/deleteRow', localId);
      }
    },

    paginate(array, size, number) {
      return array.slice((number - 1) * size, number * size);
    },

    onPageChange(v) {
      this.page = v;
    }
  }
};
</script>

<style lang="scss" scoped>
.vcv-table {
  margin: 15px 0 0;
  hyphens: auto;
  table-layout: fixed;
}
</style>
